import Container from "../../components/Container";
import { FaArrowRight } from "react-icons/fa";

export default function Benefits() {
    return <Container
        id="benefits"
        transparent
        padding={""}
        shadow={false}
        className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-4"
    >
        <h2 className={"font-bold text-3xl text-center md:col-span-3"}>Why Choose Us?</h2>

        <h3 className={"font-bold text-lg md:text-xl text-center md:col-span-3"}>
            Transparent, Reliable, Compliant, Efficient, and Defensible Property Valuation and Real Estate Outcomes
        </h3>


        {/*GENERAL CLIENTS*/}
        <div
            className={"bg-gradient-to-bl from-transparent to-blue-200 rounded-xl row-span-2 relative md:text-white md:bg-[url('img/musa-ortac-HrrWNCpoOu8-unsplash.jpg')]"}>
            <div className="hidden md:block absolute inset-0 bg-gradient-to-br from-blue-700/50 to-blue-950 opacity-70 rounded-xl"></div>

            <div className={"flex justify-end md:absolute top-0 right-0 pe-6 pt-4"}>
                <img src="img/gradient-cryptocurrency-concept-with-wallet-b.png" className={"h-[100px] w-[100px]"}
                     alt="financial institution"/>
            </div>

            <div
                className="md:absolute bottom-0 right-0 w-full flex flex-col md:flex-row justify-between items-center p-6">
                <div className={"rounded-3xl"}>
                    <div className={"font-bold text-2xl text-center md:text-left mb-2"}>General Clients</div>
                    <ul className={"list-disc ms-4 md:mb-32"}>
                        <li>Find a list of Registered Valuers & Estate Agents.</li>
                        <li>Get tips on how to add value to your home.</li>
                        <li>Get insights on how to manage your mortgage better.</li>
                    </ul>
                    <div className={"flex justify-end gap-6 mt-4"}>
                        <div>
                            <button
                                className={"border-2 border-blue-700 md:border-white text-blue-700 md:text-white py-2 px-6 rounded-xl hover:border-blue-700 hover:bg-blue-700 hover:text-white font-semibold transition-all flex items-center gap-2"}>
                                <span>Explore</span>
                                <span><FaArrowRight/></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        {/*FINANCIAL INSTITUTIONS*/}
        <div className={"py-4 px-6 bg-gradient-to-bl from-transparent to-blue-200 rounded-xl flex flex-col relative"}>
            <div className={"flex justify-end"}>
                <img src="img/gradient-cryptocurrency-concept-with-wallet-b.png" className={"h-[100px] w-[100px]"}
                     alt="financial institution"/>
            </div>
            <div className={"font-bold text-xl text-center md:text-left mb-2 md:mt-auto"}>Financial Institutions</div>
            <ul className={"list-disc ms-4"}>
                <li>Manage Property Valuation Workflows.</li>
                <li>Minimise Real Estate Risks.</li>
            </ul>
            <div className={"flex justify-end gap-6 mt-4"}>
                <div>
                    <button
                        className={"border-2 border-blue-700 text-blue-700 bg-white/30 py-2 px-6 rounded-xl hover:bg-blue-700 hover:text-white font-semibold transition-all flex items-center gap-2"}>
                        <span>Explore</span>
                        <span><FaArrowRight/></span>
                    </button>
                </div>
            </div>
        </div>


        {/*PROPERTY VALUERS*/}
        <div className={"py-4 px-6 bg-gradient-to-bl from-transparent to-blue-200 rounded-xl flex flex-col relative"}>
            <div className={"flex justify-end"}>
                <img src="img/gradient-cryptocurrency-concept-with-wallet-b.png" className={"h-[100px] w-[100px]"}
                     alt="financial institution"/>
            </div>
            <div className={"font-bold text-xl text-center md:text-left mb-2 md:mt-auto"}>Property Valuers</div>
            <ul className={"list-disc ms-4"}>
                <li>Use tools to develop property valuations in a new way.</li>
                <li>Access and manage valuation orders seamlessly</li>
            </ul>
            <div className={"flex justify-end gap-6 mt-4"}>
                <div>
                    <button
                        className={"border-2 border-blue-700 text-blue-700 bg-white/30 py-2 px-6 rounded-xl hover:bg-blue-700 hover:text-white font-semibold transition-all flex items-center gap-2"}>
                        <span>Explore</span>
                        <span><FaArrowRight/></span>
                    </button>
                </div>
            </div>
        </div>


        {/*ESTATE AGENTS*/}
        <div className={"py-4 px-6 bg-gradient-to-bl from-transparent to-blue-200 rounded-xl flex flex-col relative"}>
            <div className={"flex justify-end"}>
                <img src="img/gradient-cryptocurrency-concept-with-wallet-b.png" className={"h-[100px] w-[100px]"}
                     alt="financial institution"/>
            </div>
            <div className={"font-bold text-xl text-center md:text-left mb-2 md:mt-auto"}>Estate Agents</div>
            <ul className={"list-disc ms-4"}>
                <li>Access a pool of properties.</li>
                <li>Use tools to manage real estate transaction processes</li>
            </ul>
            <div className={"flex justify-end gap-6 mt-4"}>
                <div>
                    <button
                        className={"border-2 border-blue-700 text-blue-700 bg-white/30 py-2 px-6 rounded-xl hover:bg-blue-700 hover:text-white font-semibold transition-all flex items-center gap-2"}>
                        <span>Explore</span>
                        <span><FaArrowRight/></span>
                    </button>
                </div>
            </div>
        </div>


        {/*PROPERTY SCOUTS*/}
        <div className={"py-4 px-6 bg-gradient-to-bl from-transparent to-blue-200 rounded-xl flex flex-col relative"}>
            <div className={"flex justify-end"}>
                <img src="img/gradient-cryptocurrency-concept-with-wallet-b.png" className={"h-[100px] w-[100px]"}
                     alt="financial institution"/>
            </div>
            <div className={"font-bold text-xl text-center md:text-left mb-2 md:mt-auto"}>Property Scouts</div>
            <ul className={"list-disc ms-4"}>
                <li>Get training and mentorship.</li>
                <li>Use tools to undertake real estate property listings.</li>
                <li>Gain experience and join a network of registered valuers and licensed estate agents.</li>
            </ul>
            <div className={"flex justify-end gap-6 mt-4"}>
                <div>
                    <button
                        className={"border-2 border-blue-700 text-blue-700 bg-white/30 py-2 px-6 rounded-xl hover:bg-blue-700 hover:text-white font-semibold transition-all flex items-center gap-2"}>
                        <span>Explore</span>
                        <span><FaArrowRight /></span>
                    </button>
                </div>
            </div>
        </div>


        <div className={"w-[100vw]"}></div>
    </Container>
}